import { gql } from '@apollo/client';

import { mediaSession } from '../fragments';

export default gql`
  mutation UpdateMediaSessionProgress(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
    $mediaSessionId: String!
    $input: UpdateMediaSessionProgressInput!
  ) {
    mediaSession(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
      mediaSessionId: $mediaSessionId
      input: $input
    )
      @rest(
        type: "MediaSession"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}/sessions/{args.mediaSessionId}/update-progress"
        method: "PUT"
      ) {
      ...MediaSession
    }
  }
  ${mediaSession}
`;
